var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClue3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4608 21.8167C20.8141 20.5464 23 16.08 23 11.8167C23 7.55332 20.8121 3.0888 17.4608 1.81854H6.53917C3.1859 3.0888 1 7.55518 1 11.8185C1 16.0819 3.1859 20.5483 6.53917 21.8185L17.4608 21.8167Z",
    fill: "#E56C56"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_376_3055)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4547 17.9981C10.3094 17.9981 9.07019 17.6975 8 17.1095L8.2253 16.4875C10.76 17.0736 12.4666 16.4478 12.4666 14.7859C12.4666 13.1618 11.4547 12.5946 8.56514 12.6702L8.52571 11.706C11.8095 11.6512 12.2977 10.8571 12.2977 9.11769C12.2977 7.39909 10.591 7.00205 8.41493 7.79612L8 6.75626C9.16407 6.24389 10.2906 6 11.3044 6C13.5556 6 15.1872 7.19111 15.1872 9.10068C15.1872 10.7248 14.1545 11.6134 13.2364 12.0104C14.6633 12.502 15.2623 13.4284 15.2623 14.9598C15.2623 17.0187 13.4993 17.9981 11.4547 17.9981Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_376_3055",
    x: 8,
    y: 6,
    width: 7.82933,
    height: 12.5651,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.567,
    dy: 0.567
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.137255 0 0 0 0 0.0941176 0 0 0 0 0.0823529 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_376_3055"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_376_3055",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClue3);
export default __webpack_public_path__ + "static/media/clue3.2ccc74e3d9b29219850a2df64d6731ca.svg";
export { ForwardRef as ReactComponent };